import '../../styles/reset.css'
import '../../styles/theme.css'
import 'react-toastify/dist/ReactToastify.css'
import './App.css'
import { Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { useToastScroll } from 'shared/hooks/useToastScroll'
import { LANDING_HREF } from 'shared/constants/links.ts'
import DonationForm from '@/pages/Donation'
import MainLayout from '@/layouts/MainLayout/MainLayout.tsx'
import Redirect from '@/shared/components/Redirect'
import { routes } from '@/constants/routes'

function App() {
  useToastScroll(76)

  return (
    <>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path={routes.donate} element={<DonationForm />} />
          <Route path="*" element={<Redirect url={LANDING_HREF} />} />
        </Route>
      </Routes>
      <ToastContainer
        theme="dark"
        containerId="service"
        position="top-right"
        closeOnClick={false}
        pauseOnHover
        pauseOnFocusLoss
      />
    </>
  )
}

export default App
